import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Container } from "../layout/Container.jsx";
import { cn } from "../../lib/cn.js";

/**
 * Standard page header used across all secondary pages (everything except the
 * homepage and design detail, which have bespoke heroes). Eyebrow + display
 * title + optional description + breadcrumbs.
 */
export function PageHero({ eyebrow, title, description, breadcrumbs, children, className }) {
  return (
    <section
      className={cn("border-b border-border-subtle bg-bg-elevated py-12 lg:py-16", className)}
    >
      <Container>
        {breadcrumbs && breadcrumbs.length > 0 && (
          <Breadcrumbs items={breadcrumbs} className="mb-6" />
        )}
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h1 className="mt-3 font-display text-4xl text-text-primary lg:text-5xl">{title}</h1>
        {description && <p className="mt-4 max-w-2xl text-lg text-text-secondary">{description}</p>}
        {children}
      </Container>
    </section>
  );
}

export function Breadcrumbs({ items, className }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={cn("flex flex-wrap items-center gap-1 text-xs", className)}
    >
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={`${item.label}-${i}`} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="h-3 w-3 text-text-muted" />}
            {isLast || !item.to ? (
              <span className="text-text-secondary">{item.label}</span>
            ) : (
              <Link to={item.to} className="text-text-muted hover:text-accent">
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
